import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import CxApiMetadataActions from '../actions/cx-api-metadata.actions';
import { CxApiMetadata, CxEntityIds } from '../../models/cx-api-metadata';

export interface CxApiMetadataEntity extends CxApiMetadata {
  isLoading: boolean;
  isFetched: boolean;
  hasError: boolean;
  createdAt: number;
  expiresAt: number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CxApiMetadataState extends EntityState<CxApiMetadataEntity> {}

export const entityAdapter = createEntityAdapter<CxApiMetadataEntity>({
  selectId: ({ id }) => id,
});

export const initialCxApiMetadataState = entityAdapter.getInitialState({});

export const cxApiMetadataReducer = createReducer(
  initialCxApiMetadataState,

  on(CxApiMetadataActions.initEntity, (state, { id }) => {
    return entityAdapter.addOne(
      {
        id,
        createdAt: Date.now(),
        expiresAt: 0,
        entityIds: [] as CxEntityIds,
        isLoading: false,
        isFetched: false,
        hasError: false,
      },
      state,
    );
  }),

  on(CxApiMetadataActions.fetchEntity, (state, { id }) => {
    return entityAdapter.updateOne(
      {
        id,
        changes: {
          isLoading: true,
        },
      },
      state,
    );
  }),

  on(CxApiMetadataActions.fetchEntityCompleted, (state, { payload: { ttl, ...rest } }) => {
    return entityAdapter.updateOne(
      {
        id: rest.id,
        changes: {
          ...rest,
          expiresAt: Date.now() + ttl * 1000,
          isLoading: false,
          isFetched: true,
        },
      },
      state,
    );
  }),

  on(CxApiMetadataActions.fetchEntityCanceled, (state, { id }) => {
    return entityAdapter.updateOne(
      {
        id: id,
        changes: {
          isLoading: false,
          hasError: true,
          isFetched: true,
        },
      },
      state,
    );
  }),

  on(CxApiMetadataActions.fetchEntityReset, (state, { id }) => {
    return entityAdapter.removeOne(id, state);
  }),

  on(CxApiMetadataActions.resetState, () => {
    return initialCxApiMetadataState;
  }),
);

export function reducer(state: CxApiMetadataState, action: Action) {
  return cxApiMetadataReducer(state, action);
}

export const { selectIds, selectEntities, selectAll } = entityAdapter.getSelectors();
